module.exports = __webpack_public_path__ + "img/demo.132ddd1a.png";